import { useEffect, Button } from 'external/react'

import { clientService } from 'services/client.service'
import useFormValidation, {validators, errorText }  from 'utilities/form-validation'

import FormTextfield, { PasswordField } from 'components/FormTextfield'
import { notifyError, notifySuccess } from 'components/Notify'

import useAuth from 'context/auth-context/hook'

const { blacklistValidation, createEmailValidation, createPasswordMatchValidation, createRequiredFieldValidation, createStrongPaswordValidation } = validators

const triedEmails:string[] = [];

const registerValidations = {
	first_name: [createRequiredFieldValidation('first_name')],
	last_name: [createRequiredFieldValidation('last_name')],
	email: [createRequiredFieldValidation('email'), createEmailValidation('email'), blacklistValidation('email', triedEmails, errorText('USED_EMAIL'))],
	password: [createRequiredFieldValidation('password'), createStrongPaswordValidation('password')],
	confirmPassword: [createRequiredFieldValidation('confirmPassword'), createPasswordMatchValidation('confirmPassword', 'password')]
}

export default function RegisterForm () {

	const { update, showLogin, modals: {register: user} } = useAuth()

	const [errors, validate] = useFormValidation(registerValidations);

	async function registerHandler (e) {
		e.preventDefault();
		if (!validate(user, true)) {
			return;
		}
		const response = await clientService.createClient(user);
		if (response.data.statusResponse.success) {
			notifySuccess(response.data.statusResponse.message)
			showLogin()
		} else {
			triedEmails.push(user.email)
			notifyError(response.data.statusResponse.message)
			validate(user, true)
		}
	}

	function createFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: user[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e) => {
				update({modals: {register: {[fieldName]: {$set: e.target.value.trim()}}}})
			}
		}
	}
	
	useEffect(() => { validate(user) }, [user])

	return (
		<form autoComplete='on'>
			<FormTextfield controlProps={{autoComplete: 'firstname'}} {...createFieldProps('Nombre', 'first_name', 25)} />
			<FormTextfield controlProps={{autoComplete: 'lastname'}} {...createFieldProps('Apellido', 'last_name', 25)} />
			<FormTextfield controlProps={{autoComplete: 'email'}} {...createFieldProps('Correo', 'email')} />
			<PasswordField controlProps={{autoComplete: 'new-password'}} {...createFieldProps('Contraseña', 'password')} />
			<PasswordField controlProps={{autoComplete: 'new-password'}} {...createFieldProps('Confirmar contraseña', 'confirmPassword')} />
			<div className='actions_login mt-3'>
				<Button variant='primary' onClick={registerHandler}>Registrar</Button>
				<Button variant='light' onClick={() => showLogin()}>Iniciar Sesion</Button>
			</div>
		</form>
	)
}